var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('vertical-table', _vm._b({
    staticClass: "body-info__table"
  }, 'vertical-table', {
    items: _vm.items,
    class: {
      blinded: _vm.blinded
    }
  }, false)), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.blinded,
      expression: "blinded"
    }],
    staticClass: "body-info__overlay",
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "absolute": "",
      "dark": false,
      "color": "#F1F2F6",
      "opacity": "0.8"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg font-weight-medium primary--text"
  }, [_vm._v("호스트 연락처 정보는 로그인 후 확인 가능합니다.")]), _c('dialog-login', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-12 mt-lg-24",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 로그인 하러가기 ")])])];
      }
    }])
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }